import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import { routes } from "@/routes";
import { Root } from "@/root";
import { ADMIN_BASE, IN_ADMIN } from "@/lib/platform";
import { ScrollRestoration } from "@/components/core/scroll-restoration";

const root = createRoot(document.querySelector("#root")!);

const router = createBrowserRouter(
	[
		{
			path: "/",
			element: (
				<Root>
					<ScrollRestoration />
					<Outlet />
				</Root>
			),
			// Lazy pages are fetched before the first render; nothing to show until then.
			hydrateFallbackElement: <React.Fragment />,
			children: [...routes],
		},
	],
	IN_ADMIN ? { basename: ADMIN_BASE } : undefined
);

root.render(<RouterProvider router={router} />);
